// src/components/AddColorForm.jsx
import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "animate.css";
import "../css/addlocalidadform.css";

import {
  postColor as addColor,
  getColores,
} from "../helpers/rutaColores";

/* ---------------- utils ---------------- */
const clean = (v) => String(v ?? "").trim();

const toIntOrZero = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const normalizeColores = (r) => {
  const arr = Array.isArray(r?.colores) ? r.colores : Array.isArray(r) ? r : [];

  return arr.map((c) => ({
    ...c,
    codcolor:
      Number(
        c?.codcolor ??
          c?.codColor ??
          c?.codigocolor ??
          c?.codigo ??
          c?.cod ??
          c?.numero ??
          0
      ) || 0,
  }));
};

/* ---------------- initial ---------------- */
const initial = {
  codcolor: "",
  color: "",
};

export default function AddColorForm({ setShow, onSaved }) {
  const [formValues, setFormValues] = useState(initial);
  const [showSuccess, setShowSuccess] = useState(false);

  const [coloresState, setColoresState] = useState({
    data: [],
    loading: true,
  });

  const setField = useCallback((name, value) => {
    setFormValues((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setField(name, value.toUpperCase());
  };

  const getNextCodColor = useCallback((arr = []) => {
    const max = arr.reduce((acc, item) => {
      const n = Number(item?.codcolor ?? 0) || 0;
      return n > acc ? n : acc;
    }, 0);

    return String(max + 1);
  }, []);

  /* =========================================================
     CARGA INICIAL
  ========================================================= */
  useEffect(() => {
    getColores()
      .then((r) => {
        const data = normalizeColores(r);

        setColoresState({
          data,
          loading: false,
        });

        setFormValues((prev) => ({
          ...prev,
          codcolor: prev.codcolor || getNextCodColor(data),
        }));
      })
      .catch(() =>
        setColoresState({
          data: [],
          loading: false,
        })
      );
  }, [getNextCodColor]);

  /* ---------------- validate / payload ---------------- */
  const validate = () => {
    if (!toIntOrZero(formValues.codcolor)) {
      return "No se pudo calcular el código de color.";
    }

    if (!clean(formValues.color)) {
      return "Ingresá el color.";
    }

    return "";
  };

  const buildPayload = () => {
    const valor = clean(formValues.color).toUpperCase();

    return {
      nombre: valor,
    };
  };

  const resetForm = useCallback(
    (nextCod = "") => {
      setFormValues({
        ...initial,
        codcolor: nextCod || getNextCodColor(coloresState.data),
      });
    },
    [getNextCodColor, coloresState.data]
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    const msg = validate();
    if (msg) return alert(msg);

    const payload = buildPayload();

    try {
      const resp = await addColor(payload);

      if (resp?.ok === false) {
        console.error("❌ Error al crear color:", resp);
        return alert(resp?.error?.mensaje || resp?.error || "No se pudo guardar el color.");
      }

      const nuevoCod = Number(payload.codcolor) || 0;
      const nextCod = String(nuevoCod + 1);

      setColoresState((prev) => ({
        ...prev,
        data: [...prev.data, { codcolor: nuevoCod }],
      }));

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        resetForm(nextCod);

        if (typeof onSaved === "function") onSaved();
        if (typeof setShow === "function") setShow(false);
      }, 900);
    } catch (error) {
      console.error("❌ Error al crear color:", error?.response?.data || error);
      alert("No se pudo guardar el color. Revisá consola / Network.");
    }
  };

  return (
    <>
      {!coloresState.loading && (
        <div className="container">
          <form onSubmit={handleSubmit} noValidate>
            <div className="form-row">
              <div className="form-group mt-3 col-sm-2">
                <label>Código</label>
                <input
                  type="number"
                  className="form-control"
                  name="codcolor"
                  value={formValues.codcolor}
                  readOnly
                  placeholder="Auto"
                />
              </div>

              <div className="form-group mt-3 col-sm-6">
                <label>Color</label>
                <input
                  type="text"
                  className="form-control"
                  name="color"
                  maxLength="80"
                  value={formValues.color}
                  onChange={handleChange}
                  placeholder="Ej: ROJO"
                />
              </div>
            </div>

            <button type="submit" className="btn btn-dark mt-5 mb-3" id="button">
              Guardar
            </button>
          </form>
        </div>
      )}

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Registro generado correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
}